import React, {Component} from 'react';
import {connect} from 'react-redux';
import {actions, Control, Errors, Form} from 'react-redux-form';
import {Button, Col, Grid, Row} from 'react-bootstrap';
import qs from 'qs';
import {requestReset, verifyPIN} from '../../../actions/login';
import PageTitle from '../../common/page-title';
import LockPopup from '../lock-popup';
import TextViewer from '../../common/editor/text-viewer';

import './style.css';
import {USER_TYPE_REP, USER_TYPE_RETAILER, USER_TYPE_ADMIN} from '../../../data/userTypes';
import IgniteUkLogo from '../../../assets/img/ignite_logo_black.png';

class PINForm extends Component {
  state = {
    showNewPin: false,
    showLockPopup: false,
    pinExpired: false
  };

  handleSubmit = (payLoad) => {
    const {dispatch, area} = this.props;

    const redirectUrl = {
      [USER_TYPE_RETAILER]: '/seq-questions',
      [USER_TYPE_ADMIN]: '/admin/seq-questions',
      [USER_TYPE_REP]: '/team/seq-questions',
    };

    let state = null;
    if (this.props.location.search) {
      const params = qs.parse(this.props.location.search.slice(1));
      if (params.state) {
        // eslint-disable-next-line prefer-destructuring
        state = params.state;
      }
    }
    const pLoad = {
      ...payLoad,
      state
    };

    dispatch(actions.submitFields('deep.resetPW.step2', verifyPIN(pLoad, redirectUrl[area])
      .catch((error) => {
        dispatch({
          type: 'VERIFY_PIN_REJECTED',
          payLoad: error.response.data
        });
        dispatch(actions.load('deep.resetPW.step2.pin', ''));

        const {errors} = error.response.data;
        const rejectErrors = [];
        if (Object.prototype.toString.call(errors.pin) === '[object Array]') {
          errors.pin.forEach((curr) => {
            if (curr === 'PIN_EXPIRED') {
              rejectErrors.push({pin_expired: true});
              this.setState({pinExpired: true});
            }
            if (curr === 'INVALID_CREDENTIALS') {
              rejectErrors.push({invalid_creds: true});
            }
            if (curr === 'INVALID_PIN') {
              rejectErrors.push({invalid_pin: true});
              this.setState({showNewPin: true});
            }
            if (curr === 'INVALID_STATE') {
              rejectErrors.push({invalid_state: true});
            }
            if (curr === 'ACCOUNT_LOCKED') {
              rejectErrors.push({locked: true});
              this.setState({showLockPopup: true});
            }
          });
          return Promise.reject(rejectErrors);
        }
        return Promise.reject(errors.user);
      })));
  };
  requestNeWPIN = () => {
    const {dispatch, area} = this.props;

    const redirectUrl = {
      [USER_TYPE_RETAILER]: '/enter-pin',
      [USER_TYPE_REP]: '/team/enter-pin',
    };

    dispatch(actions.submit('deep.resetPW.step1', requestReset(null, redirectUrl[area])
      .catch((error) => {
        dispatch({
          type: 'PW_RESET_VALUE_REJECTED',
          payLoad: error.response.data
        });

        const {errors} = error.response.data;
        if (Object.prototype.toString.call(errors) === '[object Array]') {
          errors.forEach((curr) => {
            if (curr === 'ACCOUNT_LOCKED') {
              this.setState({showLockPopup: true});
            }
          });
        }
      })));
  };
  resetErrors = () => {
    this.props.dispatch(actions.resetErrors('deep.resetPW.step2'));
  };

  componentWillMount() {
    const {dispatch} = this.props;
    dispatch(actions.reset('deep.resetPW.step2'));
  }

  render() {
    return (
      <Grid fluid className="pin-form-wrapper user-inner-container">
        <Col md={8}>
          <Row>
            <img src={IgniteUkLogo} alt="Ignite UK" />
            <PageTitle>
              Please enter your pin
            </PageTitle>
            <TextViewer pageSlug='enter-pin'/>
            If you have received multiple PIN number emails/SMS messages as a result of trying to reset your password
            more than once, please enter the PIN number from your most
            recent email/SMS.
          </Row>

          {!this.state.showNewPin && (
            <Row>
              <Form
                className="pin-form"
                model="deep.resetPW.step2"
                onChange={() => this.resetErrors()}
                onSubmit={values => this.handleSubmit(values)}
              >

                <label htmlFor=".pin">
                  Please enter your PIN
                </label>
                <Control.text className="pin-field form-control" model=".pin" type="text"/>

                <Errors
                  className="errors"
                  model=".pin"
                  show={{
                    touched: true
                  }}
                />

                <Errors
                  className="errors"
                  messages={{
                    pin_expired: 'PIN expired',
                    invalid_creds: 'Invalid Credentials',
                    invalid_pin: 'Invalid PIN given',
                    invalid_state: 'Invalid State',
                    pin_exceeded: 'PIN attempts exceeded'
                  }}
                  model="deep.resetPW.step2"
                />

                <Button
                  className="red-btn pull-left"
                  disabled={!this.props.formValid}
                  type="submit"
                >
                  Submit
                </Button>


              </Form>
            </Row>
          )}
          {this.state.showNewPin && (
            <Row>
              {this.state.pinExpired && (
                <Col className="centered" lg={12}>
                  PIN code expired
                </Col>
              )}
              <Col className="centered" lg={12}>
                Your PIN number could not be verified, please request a new PIN
                <br/>
                <Button
                  bsSize="large"
                  className="red-btn"
                  onClick={() => {
                    this.setState({
                      showNewPin: false,
                      pinExpired: false
                    });
                    this.requestNeWPIN();
                  }}
                >
                  REQUEST NEW PIN
                </Button>
              </Col>
            </Row>
          )}
          {this.state.showLockPopup && <LockPopup route="/login"/>}

        </Col>
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  formValid: state.deep.forms.resetPW.step2.$form.valid
});

export default connect(mapStateToProps)(PINForm);



// WEBPACK FOOTER //
// ./src/components/auth/forgotten-password-2/index.jsx